import React from 'react';
import UserWalletDetails from '../components/management/UserWalletDetails';

const UserWalletDetailsPage = () => {
    return <UserWalletDetails />;
};

export default UserWalletDetailsPage;
